import React from 'react'
import { Lock } from 'lucide-react'
import { Card } from './Card'
import { Button } from './Button'
import { useNavigate } from 'react-router-dom'
import { useAppPath } from '../../hooks/useAppPath'

interface AccessDeniedCardProps {
  feature?: string
  message?: string
}

export const AccessDeniedCard: React.FC<AccessDeniedCardProps> = ({
  feature,
  message,
}) => {
  const navigate = useNavigate()
  const appPath = useAppPath()

  return (
    <div className="flex items-center justify-center min-h-[60vh] px-4">
      <Card className="max-w-md w-full p-8 text-center">
        <div className="mx-auto w-16 h-16 rounded-full bg-slate-100 dark:bg-slate-800 flex items-center justify-center mb-4">
          <Lock className="h-8 w-8 text-slate-400" />
        </div>
        <h2 className="text-xl font-semibold text-slate-900 dark:text-slate-100 mb-2">
          Access Restricted
        </h2>
        <p className="text-slate-600 dark:text-slate-400 mb-6">
          {message || `You don't have permission to access ${feature || 'this feature'}. Contact your account administrator to request access.`}
        </p>
        <Button onClick={() => navigate(appPath('/dashboard'))} variant="outline">
          Back to Dashboard
        </Button>
      </Card>
    </div>
  )
}
